<template>
  <div>
    <b-card>
      <div
        class="m-2"
        md="12"
      >
        <b-row>
          <b-col
            cols="12"
            md="6"
            sm="12"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Ver</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>Lista</label>
          </b-col>

          <b-col
            cols="12"
            md="6"
            sm="12"
          >
            <div
              class="d-flex align-items-center justify-content-end"
            >
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                variant="primary"
                @click="search"
              >
                <span class="text-nowrap">
                  <feather-icon icon="SearchIcon" />
                  Consultar</span>
              </b-button>
              <b-button
                variant="success"
                hidden
                @click="newContract"
              >
                <span class="text-nowrap">
                  <feather-icon icon="PlusIcon" />
                  Solicitud Contrato</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-table
          id="my-table"
          ref="refUserListTable"
          striped
          hover
          small
          class="position-relative"
          :items="items"
          responsive
          :fields="fields"
          :sort-by.sync="sortBy"
          show-empty
          :filter="searchQuery"
          empty-text="No existen registros para mostrar"
          :sort-desc.sync="isSortDirDesc"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle" />
              <strong>Cargando...</strong>
            </div>
          </template>

          <template #cell(pagar)="data">
            <b-button
              v-b-modal.modal-checkout
              :variant="`${
                data.item.balance_pesos > 0
                  ? 'danger'
                  : 'success'
              }`"
              block
              @click="pagar(data.item)"
            >
              {{
                data.item.balance_pesos > 0
                  ? `Pagar: ${data.item.balance_pesos}`
                  : `Cuenta al dia`
              }}
            </b-button>
          </template>

          <template #cell(status)="data">
            <b-badge
              pill
              :variant="data.item.class"
            >
              {{ data.item.estado }}
            </b-badge>
          </template>

          <template #cell(resumen)="data">
            <b-button
              variant="info"
              size="sm"
              @click="resumenContract(data.item.idcontrato)"
            >
              Resumen
            </b-button>
          </template>

          <template #custom-foot>
            <tr>
              <td
                colspan="5"
                align="right"
                class="bg-light-danger text-white"
              >
                TOTAL:
              </td>
              <td
                class="bg-light-danger text-white"
                align="right"
              >
                {{ total }}
              </td>
              <td
                colspan="2"
                class="bg-light-danger text-white"
              />
            </tr>
          </template>
        </b-table>
      </div>

      <div>
        <b-row v-if="total > 0">
          <b-col
            lg="12"
            sm="12"
          >
            <statistic-card-horizontal
              icon="CheckIcon"
              color="danger"
              :statistic="total"
              statistic-title="Total Balance"
            />
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal
      id="modal-checkout"
      ref="modal-checkout"
      content-class="shadow"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      no-close-on-backdrop
      size="lg"
      title="Pago"
    >
      <checkout
        :contract="contract"
        :idcontrato="contract.idcontrato"
      />
    </b-modal>
  </div>
</template>

<script>
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue"
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BFormInput,
  BRow,
  BSpinner,
  BTable,
} from "bootstrap-vue"
import vSelect from "vue-select"
import Checkout from "./Checkout.vue"
import useList from "./useList"

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BSpinner,
    BBadge,
    BFormInput,
    BButton,
    vSelect,
    StatisticCardHorizontal,
    Checkout,
  },
  setup() {
    const {
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
    } = useList()

    return {
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
    }
  },
  data() {
    return {
      isBusy: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      fields: [
        {
          key: "pagar",
          label: "Pagar",
          class: "text-center",
        },
        { key: "codigo", label: "Codigo", sortable: true },
        { key: "apenom", label: "Nombre", sortable: true },
        { key: "direccion", label: "Dirección", sortable: true },
        {
          key: "status",
          label: "Estado",
          class: "text-center",
        },
        {
          key: "balanceContract",
          label: "Balance",
          sortable: true,
          class: "text-right",
        },
        {
          key: "resumen",
          label: "Resumen",
          class: "text-center",
        },
      ],
      items: [],
      contract: {
        idcontrato: null,
      },
    }
  },
  computed: {
    total () {
      let suma = 0
      for (let i = 0; i < this.items.length; i++) {
        suma += parseFloat(this.items[i].balance_pesos)
      }

      return suma.toFixed(2)
    },
  },
  created() {
    this.search()
  },
  methods: {
    search() {
      this.isBusy = true
      this.$http
        .get("/usuario-contrato", {
          params: {
            idusuario: this.userData.id,
            estado: "A",
          },
        })
        .then((response) => {
          this.isBusy = false
          this.items = response.data.data
        })
        .catch((error) => {
          console.log(error)
          this.isBusy = false
          this.$swal({
            title: "Error",
            text: error.response.data.error,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-danger",
            },
            buttonsStyling: false,
          })
        })
    },
    newContract() {},
    resumenContract(idcontrato) {
      this.$router.push({
        name: "contract-id",
        params: { id: idcontrato },
      })
    },
    pagar(item) {
      this.contract = item
    },
  },
}
</script>
